module.exports = __webpack_public_path__ + "f5853e85d0a0680604b44d3e15836322.woff2";